<div class="{{look}} px-0 h-100 w-100">
  <div class="d-flex flex-row expandicons">
    <div *ngIf="navigationSwitch" (click)="toggleNavigation()" class="edgeToggle" style="z-index: 1;">
      <img *ngIf="!modelService.systemService.showMenu" src="/images/ikon_Arrow_right_big.png" class="menuToggleImage" />
      <img *ngIf="modelService.systemService.showMenu" src="/images/ikon_Arrow_left_big.png" class="menuToggleImage" />
    </div>
  </div>
  <div class="detail h-100 d-flex flex-column" style="margin-top: -20px;">
    <ng-content select="[slot=content]"></ng-content>
  </div>
</div>
